/* Common Imports */
import React, { useRef } from "react";
/* Component Imports */
import Layout from "../components/layout-components/Layout";
import AboutLocation from "../components/page-sections/eden/AboutLocation";
import Amenities from "../components/page-sections/eden/Amenities";
import Appreciation from "../components/page-sections/eden/Appreciation";
import AvailableUnitsSection from "../components/page-sections/eden/AvailableUnitsSection";
import BeforeAfterSlider from "../components/page-sections/eden/BeforeAfterSlider";
import TimeOfTheDaySlider from "../components/page-sections/eden/TimeOfTheDaySlider";
import VirtualTour from "../components/page-sections/eden/VirtualTour";
import ContactUs from "../components/page-sections/index/ContactUs";
// import Work from "../components/page-sections/SingleProperty/Work";
// import SpecificationAnimations from "../components/page-sections/SingleProperty/SpecificationAnimations";
// import SpecificationsCust from "../components/page-sections/SingleProperty/SpecificationsCust";
// import SpecificationNew from "../components/page-sections/SingleProperty/SpecificationNew";
import FloorMobileViewSection from "../components/page-sections/eden/FloorMobileViewSection";
import PropertyImage from "../components/page-sections/eden/PropertyImage";
import SpaciousSection from "../components/page-sections/eden/SpaciousSection";
import SpecificationStaticSection from "../components/page-sections/eden/SpecificationStaticSection";
/* Session Imports */
import { withIronSessionSsr } from "iron-session/next";
import AmenitiesMobile from "../components/page-sections/eden/AmenitiesMobile";
import FloorPlanSection from "../components/page-sections/eden/FloorPlanSection";
import GallerySection from "../components/page-sections/eden/GallerySection";
// import KnowMore from "../components/page-sections/eden/KnowMore";
import ProjectDetailsSection from "../components/page-sections/eden/ProjectDetailsSection";
import LegendaryBeginningMobile from "../components/page-sections/eden/subcomponents/LegendaryBeginningMobile";
import ProjectDetailsMobileCards from "../components/page-sections/eden/subcomponents/ProjectDeatilsMobileCard";
import TimeofTheDaySection from "../components/page-sections/eden/TimeofTheDaySection";
import { sessionOptions } from "../lib/session";

const Eden = ({ user }) => {
  const legendaryRef = useRef(null);
  const [showBottomNav, setShowBottomNav] = React.useState(false);

  // Disable scroll restoration
  if (typeof window !== "undefined") {
    window.history.scrollRestoration = "manual";
  }

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowBottomNav(!entry.isIntersecting); // Show BottomNav when not intersecting
      },
      { threshold: 0.1 }, // Trigger when 10% of the element is visible
    );

    if (legendaryRef.current) {
      observer.observe(legendaryRef.current);
    }

    return () => {
      if (legendaryRef.current) {
        observer.unobserve(legendaryRef.current);
      }
    };
  }, []);
  return (
    <React.Fragment>
      <Layout
        noContainer
        user={user}
        title="Premium 2 BHK Homes In Sarjapur Road | Sentient Eden"
        description="Discover sentient eden premium 2 & 3 BHK eco-friendly homes in sarjapur road. Experience sustainable living with modern comforts and green spaces. Book now!"
        showBottomNav={showBottomNav}
      >
        <PropertyImage />
        <div ref={legendaryRef}>
          <LegendaryBeginningMobile />
        </div>
        <ProjectDetailsMobileCards />
        <SpaciousSection />
        <ProjectDetailsSection />
        <AvailableUnitsSection />
        <FloorPlanSection />
        <FloorMobileViewSection />
        <VirtualTour />

        {/* <ApartmentKey /> */}
        <AmenitiesMobile />
        {/* <SpaciousBHK /> */}
        {/* <FloorMobView /> */}
        {/* <FloorPlansGSAP /> */}
        {/* <ProjectDetails /> */}
        <Amenities />
        {/* <Gallery /> */}
        <BeforeAfterSlider />
        <TimeofTheDaySection />
        <GallerySection />
        <TimeOfTheDaySlider />
        {/* <TimeOfTheDayIcons /> */}
        <AboutLocation />
        <Appreciation />
        {/* <IGBC /> */}
        {/* <Work /> */}
        <SpecificationStaticSection />
        {/* <SpecificationStatic /> */}
        {/* <SpecificationNew /> */}
        {/* <SpecificationAnimations /> */}
        {/* <SpecificationsCust /> */}
        {/* <KnowMore /> */}
        <ContactUs source="Heavie Eden" />
      </Layout>
    </React.Fragment>
  );
};
export default Eden;

// eslint-disable-next-line space-before-function-paren
export const getServerSideProps = withIronSessionSsr(async function ({ req, res }) {
  /* Getting user session cookie */
  const user = await req.session.user;

  /* User Authorization */
  if (user == undefined) {
    return {
      props: {
        user: { isLoggedIn: false },
      },
    };
  } else {
    /* Pass data to the page via props */
    return {
      props: { user: req.session.user },
    };
  }
}, sessionOptions);
